import React from 'react';

const Skills = () => {
    return (
        <div className='h-screen'>
            
        </div>
    );
};

export default Skills;